module.exports = __webpack_public_path__ + "static/media/creativ9.ddb4e0be.jpg";